<template>
  <!-- <v-row>
    <v-col cols="12">
      <h1>調訓名單列印</h1>
    </v-col>
  </v-row> -->
  <VCard>
    <VCardText>
      <v-row>
        <v-col cols="3">
          <v-select v-model="viewParams.filter.projectId" :items="viewParams.projectSelect" 
            item-title="1"
            item-value="0"
            label="計畫項目" clearable></v-select>
        </v-col>
        <v-col cols="3">
          <v-select label="培訓階段"
            item-title="1"
            item-value="0"
            v-model="viewParams.filter.stage"
            :items="viewParams.stageSelect" 
            :disabled="!viewParams.filter.projectId"></v-select>
        </v-col>
        <v-col cols="3">
           <v-select label="協會"
            item-title="1"
            item-value="0"
            v-model="viewParams.filter.deptNo"
            :items="viewParams.deptNoSelect" 
            :disabled="!viewParams.filter.stage"></v-select>
        </v-col>
        <!-- <v-col cols="3" class="d-flex justify-end">
          <VBtn
            icon="tabler-search"
            color="primary"
            @click="search"/>
        </v-col> -->
      </v-row>
    </VCardText>
  </VCard >


  <VCard class="mt-4">
    <VCardText>
      <VRow>
        <VCol cols="4" class="d-flex align-center">
          <h3>培訓隊清單</h3>
        </VCol>
        <VCol cols="8" class="d-flex justify-end">
          <v-btn prepend-icon="tabler-download" @click="download" :loading="viewParams.dwnLoading" :disabled="!tableSelect.selected.length">
            下載
          </v-btn>
        </VCol>
      </VRow>
    </VCardText>
    <VDivider />

    <v-data-table :items="tbtca16Vos" :headers="tbtca16VosHeaders" fixed-header height="350px" 
    v-model="tableSelect.selected"
    return-object
    :loading="viewParams.loading"
    show-select items-per-page="-1">
    <template v-slot:bottom> </template>
  </v-data-table>
  </VCard>
</template>

<script setup lang="ts">
  definePage({
    meta: {
      action: 'manage',
      subject: 'TRAININGLISTPRINT',
    },
  })

  const viewParams = reactive({
    projectSelect: [],
    stageSelect:[],
    deptNoSelect:[],
    filter: {
      projectId: '',
      stage:'',
      deptNo: ''
    },
    dwnLoading: false,
    loading: false
  });
  const tableSelect = reactive({
    selected: []
  });

  const tbtca16Vos = reactive([]);
  const tbtca16VosHeaders = [
    { title: '職稱', key: 'position', sortable: false },
    { title: '姓名', key: 'name', sortable: false },
    { title: '性別', key: 'gender', sortable: false },
    { title: '出生年月', key: 'birth_date', sortable: false },
    { title: '服務單位/就讀學校及年級', key: 'service_or_school', sortable: false },
    { title: '地址', key: 'address', sortable: false },
    // { title: '項目/量級/位置', key: 'event_or_position', sortable: false },
    // { title: '符合培訓標準或遴選', key: 'eligibility', sortable: false }
  ];

  onMounted(() => {
    getSelectList();
  })

  
  watch(() => viewParams.filter.projectId , async (newValue) => {
    viewParams.stageSelect.length = 0;
    viewParams.filter.stage = '';
    tbtca16Vos.length = 0;
    tableSelect.selected.length = 0;
    getStageSelect(viewParams.filter.projectId);
  });

  watch(() => viewParams.filter.stage , async (newValue) => {
    viewParams.deptNoSelect.length = 0;
    viewParams.filter.deptNo = '';
    tbtca16Vos.length = 0;
    tableSelect.selected.length = 0;
    if(viewParams.filter.stage) {
      getDeptNoSelect(viewParams.filter.projectId, viewParams.filter.stage);
    }
  });

  watch(() => viewParams.filter.deptNo , async (newValue) => {
    if(viewParams.filter.deptNo) {
      search();
    }
  });

  const getSelectList = async () => {
    await $api('/tca/traininglistprint/get/project/select', {
      method: 'GET',
    }).then((resp) => {
      if (resp.statusCode != 200) {
        popSwal('error','下拉選單讀取失敗！'+resp.data);
        return ;
      }

      Object.assign(viewParams.projectSelect, resp.data); 
    });
  };

  const getStageSelect = async (projectId) => {

    if(!projectId) {
      return;
    }

    const apiUrl='/tca/traininglistprint/get/stage/select/'+projectId
    await $api(apiUrl, {
      method: 'GET'
    }).then((resp) => {

      if (resp.statusCode != 200) {
        popSwal('error','下拉選單讀取失敗！'+resp.data);
        return ;
      }
      // 轉換 第一階段：1，第二階段第一期：2.1 ，以此類推
      const regex = /(\d+)\.?(\d?)/;
      resp.data.forEach( (item) =>{
        let dispStage = '';
        let stage = item[0];
        const matches = stage.match(regex);
        if(matches) {
          let cNum = numberToChinese(matches[1]);
          dispStage = '第' + cNum + '階段';
          if(matches[2]) {
            cNum = numberToChinese(matches[2]);
            dispStage = dispStage + '第' + cNum +'期';
          }
        } else {
          dispStage = '建議參賽名單';
        }
        item[1] = dispStage + ' ' + item[1];
      });
      Object.assign(viewParams.stageSelect, resp.data); 
    })
  };

  const getDeptNoSelect = async (projectId, stage) => {
    if(!projectId) {
      return;
    }
    const apiUrl='/tca/traininglistprint/get/deptNo/select/'+projectId+'/'+stage
    await $api(apiUrl, {
      method: 'GET'
    }).then((resp) => {
      if (resp.statusCode != 200) {
        popSwal('error','下拉選單讀取失敗！'+resp.data);
        return ;
      }
      Object.assign(viewParams.deptNoSelect, resp.data); 
    })
  };


  const search = async () => {
    viewParams.loading = true;
    tbtca16Vos.length = 0;
    tableSelect.selected.length = 0;
    const apiUrl='/tca/traininglistprint/search'
    await $api(apiUrl, {
      method: 'POST',
      body: viewParams.filter
    }).then((resp) => {
      if (resp.statusCode == 200) {
        popSwal('success','搜尋成功');
        Object.assign(tbtca16Vos, resp.data); 
      } else  {
        popSwal('error','搜尋失敗,錯誤訊息'+resp.data);
      }
      viewParams.loading = false;
    })
  };

  const download = async () => {
    viewParams.dwnLoading = true;
    const apiUrl='/tca/traininglistprint/download'
    await $api(apiUrl, {
      method: 'POST',
      body: {
        projectText: viewParams.projectSelect.find(select => select[0] === viewParams.filter.projectId)[1],
        stageText: viewParams.stageSelect.find(select => select[0] === viewParams.filter.stage)[1],
        deptNoText: viewParams.deptNoSelect.find(select => select[0] === viewParams.filter.deptNo)[1],
        tbtca16Vos: tableSelect.selected
      }
    }).then((resp) => {
      viewParams.dwnLoading = false;
      if (resp.statusCode == 400) {
        popSwal('error','下載失敗,錯誤訊息：'+resp.data);
        return ;
      }
      var fileURL = window.URL.createObjectURL(new Blob([resp]));
      var fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', '調訓名單列印_'+new Date().getTime()+'.xlsx');
      document.body.appendChild(fileLink);
      fileLink.click();
    })
  };


  const popSwal = (icon,title) => {
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      showConfirmButton: false,
      timer: 3000,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }
  function numberToChinese(num) {
    const chineseDigits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    let chineseNum = '';
    // 处理整数部分
    const integerPart = Math.floor(num);
    if (integerPart > 0) {
      const digits = integerPart.toString().split('').reverse();
      for (let i = 0; i < digits.length; i++) {
        if (digits[i] !== '0') {
          chineseNum = chineseDigits[digits[i]] +  chineseNum;
        } else {
          // 处理连续的零
          if (chineseNum.length > 0 && chineseNum[chineseNum.length - 1] !== '零') {
            chineseNum += '零';
          }
        }
      }
    }
    return chineseNum;
  }
</script>

<style scoped>
/* Add your styles here */
</style>
